<template>
  <v-container fluid class="pa-4 pa-sm-6">
    <global-confirm-box ref="confirmBox"></global-confirm-box>
    <v-row>
      <v-col cols="12">
        <h3 class="tab_style_header">{{ $t("your_profile") }}</h3>
        <p style="color: rgba(0, 0, 0, 0.5)">{{ $t("edit_profile") }}</p>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" sm="4">
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item v-for="(item, i) in [$t('gen_info'), $t('password')]" :key="i">
            <v-list-item-content>
              <v-list-item-title v-text="item"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-col>
      <v-col cols="12" sm="8" v-if="selectedItem === 0">
        <profile-general-info
          :user="user"
          @delete-profile="deleteProfileConfirm"
          @profile-updated="handleProfileUpdated"
        />
      </v-col>

      <v-col cols="12" sm="8" v-if="selectedItem === 1">
        <profile-password-change
          :user-id="user.id"
          @password-changed="handlePasswordChanged"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";
import ProfileGeneralInfo from "@/components/profile/ProfileGeneralInfo.vue";
import ProfilePasswordChange from "@/components/profile/ProfilePasswordChange.vue";

export default {
  components: {
    ProfileGeneralInfo,
    ProfilePasswordChange,
  },
  mixins: [hasSnackbar],
  data: () => ({
    selectedItem: 0,
  }),
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  methods: {
    handleProfileUpdated(updatedUser) {
      // Update store if needed
      this.$store.commit("user/UPDATE_USER", updatedUser);
    },

    handlePasswordChanged() {
      // Optional: Switch back to general info tab after password change
      // this.selectedItem = 0;
    },

    deleteProfileConfirm() {
      this.$refs.confirmBox
        .open(this.$t("delete_profile"), this.$t("delete_profile_confirmation"), {
          color: "error",
        })
        .then(() => {
          this.deleteProfile();
        })
        .catch(() => {
          // User cancelled
        });
    },

    async deleteProfile() {
      try {
        await userService.deleteProfile(this.user);

        localStorage.removeItem("restoran-token");
        this.$store.commit("user/LOGOUT", null);
        this.$store.commit("SAVE_RESTAURANT", null);
        this.$store.commit("SAVE_COMPANY", null);

        this.$router.push({ name: "restorani-guest" });
        this.showSuccessSnackbar(this.$t("profile_deleted"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_deleting_profile"));
      }
    },
  },
};
</script>

<style scoped>
label,
p,
div {
  font-family: "Poppins", Helvetica, sans-serif !important;
}
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin: 1em 0;
  padding: 0;
}
.avatar-user {
  width: 150px;
  margin: 0 auto;
  display: block;
  margin-top: 50px;
}
.tab_style {
  font-size: 18px;
  font-family: "Poppins", Helvetica, sans-serif;
}
.tab_style_header {
  font-size: 28px;
  font-family: "Poppins", Helvetica, sans-serif;
}
.tab_style_sub_tekst {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.55);
}
</style>
